import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-button-component',
  templateUrl: './formButton.component.html',
  styleUrls: ['./formButton.component.scss'],
})
export class FormButtonComponent {
  @Input() text: string;
  @Input() disabled: boolean;
}



// WEBPACK FOOTER //
// ./src/app/common/components/FormButtonComponent/formButton.component.ts